import React, { useState } from 'react'
import PropTypes from 'prop-types';
import { Link, useNavigate } from 'react-router-dom';
import "./css/login.css"
import image2 from "./../image2.png"
import image3 from "./../image3.png"
import image4 from "./../image4.png"
import logo from '../../src/agri.png';
import Swal from 'sweetalert2';

const BASE_URL = process.env.REACT_APP_BASE_URL

async function loginUser({
  username,
  password
}) {
  return fetch(BASE_URL + 'auth/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      username,
      password
    })
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      return data.accessToken;
    });
}

export default function Login() {

  const [username, setUserName] = useState();
  const [password, setPassword] = useState();
  const navigate = useNavigate();


  const handleSubmit = async e => {
    e.preventDefault();
    const token = await loginUser({
      username,
      password
    });

    if (token != null) {
      localStorage.setItem("token", token)
      localStorage.setItem("email", username)
      // setToken(token);
      navigate('/info');
    }
    else {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Email or password is incorrect!',
      })
    }

  }

  localStorage.setItem("email", username);

  return (
    <>
      <nav className="navbar navbar-expand-lg fixed-top">
        <div className="container d-flex justify-content-center">
          <Link className="navbar-brand" to={'/sign-in'}>
          </Link>
        </div>
        <div className="container d-flex justify-content-center">
          <Link className="navbar-brand" to={'/sign-in'}>
            <img src={logo} class='radius-img' alt="Logo" width={100} height={80} />
          </Link>
        </div>
        <div className="container d-flex justify-content-center">
          <Link className="navbar-brand" to={'/sign-in'}>
          </Link>
        </div>
      </nav>
      <div class="container">
        <div className="">
          <div className="">
            <img src={image2} alt="Logo" width={230} height={230} />
            <div class='box'>
              <img src={image3} alt="Logo" width={170} height={170} />
            </div>

          </div>
        </div>
        <div className="auth-wrapper">
          <div className="auth-inner">
            <form onSubmit={handleSubmit}>
              <h3>Sign In</h3>
              <div className="mb-3">
                <label>Username</label>
                <input
                  type="email"
                  className="form-control"
                  placeholder="Enter username"
                  onChange={e => setUserName(e.target.value)}
                />
              </div>
              <div className="mb-3">
                <label>Password</label>
                <input
                  type="password"
                  className="form-control"
                  placeholder="Enter password"
                  onChange={e => setPassword(e.target.value)}
                />
              </div>
              <div className="mb-3">
              </div>
              <div className="d-grid">
                <button type="submit" className="btn btn-success">
                  Sign in
                </button>
              </div>
              <p className="forgot-password text-right">
                <Link to='/sign-up'>Registration</Link>
              </p>
            </form>
          </div>
        </div>
        <div className="">
          <div className="">
            <img src={image4} alt="Logo" width={270} height={270} />
          </div>
        </div>

      </div>
    </>
  )
}

Login.propTypes = {
  setToken: PropTypes.func.isRequired
};